import "./millennium.browser.scss"
import { Client, Session, EventEmitter, getDefaultSession, getCurrentHost } from "lib/wts.client"
import { IMillenniumBrowser, IMillenniumFrame, IRoute, ICommand, FeedBackData, LazyLoadFacet, MsgBoxFlags, MsgBoxResult, IMillenniumNativeFrame, IModalWindow, IModalWindowOptions, INotificationSource, INotificationItem } from 'lib/millennium.core'
import { loadModule, loadExtension, loadNotifiers } from "../millennium.modules"
import { CommandDialogWindow, Dialog, DialogWindowCommand, getTopOverlayElement, Menu } from "lib/wts.ui.overlays"
import { LoadIndicator } from "lib/wts.ui.indicators"
import { Md5 } from 'ts-md5'
import { Environment } from "lib/wts.platform"
import browserHtmlTemplate from "./millennium.browser.html"
import "lib/wts.ui.controls.tree";
import { MlnTreeView } from "lib/wts.ui.controls.tree";
import { Capacitor } from "@capacitor/core"
import { LiveUpdate } from "@capawesome/capacitor-live-update"

export async function showLogin(options?: { message?: string, blank?: boolean, canCancel?: boolean }) {
    const dialogContent = document.createElement("div")
    dialogContent.className = "login-dialog-modal_body"
    dialogContent.id = "login-div"
    dialogContent.style.padding = "10px"
    dialogContent.style.background = "transparent"
    dialogContent.innerHTML = /*html*/ ` 
                    <mln-logo-image style="--logo-text-color:black"></mln-logo-image>

                    <div id="login-dialog-modal_message"></div>
                    <!-- user -->
                    <div class="flex-row flex-align-center form-control input-area">
                        <span class="input-group-addon fa fa-user"
                            style="background:none;border:none;padding:0px 5px 0px 0px"></span>
                        <input autocomplete="off" class="" id="username" type="text"
                            placeholder="Usuário" style="border:none;background:none">
                    </div>
                    <!-- pass -->
                    <div class="flex-row flex-align-center form-control input-area">
                        <span class=" input-group-addon fa fa-key"
                            style="background:none;border:none;padding:0px 5px 0px 0px"></span>
                        <input autocomplete="off" class="" id="password" type="password" 
                            placeholder="Senha" style="border:none;background:none"/>
                    </div>
                    <div style="height:20px"></div>
                    <div class="login-dialog-modal_buttons mln-button-area" style="margin-top:auto">
                        <button id="login_modal" class="mln-button"
                            >ENTRAR</button>
                        <button id="login_cancel_modal" class="mln-button"
                           >CANCELAR</button>                        
                    </div>
                    `

    const dialog = new Dialog()

    if (!options?.blank) {
        dialogContent.querySelector<HTMLInputElement>("#username")!.value = getDefaultSession().userName
        dialogContent.querySelector<HTMLInputElement>("#username")!.disabled = true
    }
    dialogContent.querySelector<HTMLInputElement>("#login_cancel_modal")!.hidden = !options?.canCancel
    dialogContent.querySelector<HTMLDivElement>("#login-dialog-modal_message")!.innerText = options?.message ?? ""
    dialogContent.querySelector<HTMLDivElement>(".login-dialog-modal_buttons")!.onclick = (e: Event) => {
        if (!(e.target instanceof HTMLButtonElement)) return
        dialog.close(e.target.id)
    }
    dialogContent.onkeydown = (e: KeyboardEvent) => {
        if (e.key === "Enter") {
            dialog.close("login_modal")
        }
        if (e.key === "Escape") {
            dialog.close("login_cancel_modal")
        }
    }

    let username: string | undefined
    let password: string | undefined
    const dialogResult = await dialog.show(dialogContent, {
        className: "login-dialog-modal",
        lightDismiss: false,
        width: "auto",
        height: "auto",
        minHeight: "fit-content",
        topLayer: true,
        closeCallback: (result?: string) => {
            if (result === "login_modal") {
                username = dialogContent.querySelector<HTMLInputElement>("#username")!.value
                password = dialogContent.querySelector<HTMLInputElement>("#password")!.value
                if (!username || !password) return false
            }
            return true
        }
    })

    dialogContent.remove()

    return dialogResult === "login_modal" && username && password ? { username, password } : undefined
}


class NativeFrame implements IMillenniumNativeFrame {
    resize(left: number, top: number, width: number, height: number, visible: number): void {
        return this.browser.resizeNativeFrame(this.handle, left, top, width, height, visible)
    }
    navigate(place: string): void {
        return this.browser.navigateNativeFrame(this.handle, place)
    }
    destroy(): void {
        return this.browser.destroyNativeFrame(this.handle)
    }
    constructor(private browser: MillenniumBrowser, private handle: number) {

    }
}

class MlnActivityIndicator extends HTMLElement {
    connectedCallback() {
        this.innerHTML =  /*html*/`        
        <div class="pos-activity-panel flex-col flex-align-center" style="margin:auto">              
                <div class="windows8" style="width:50px;height:50px;position:relative">
                   
                    <div class="wBall" id="wBall_1">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_2">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_3">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_4">
                        <div class="wInnerBall">
                        </div>
                    </div>
                    <div class="wBall" id="wBall_5">
                        <div class="wInnerBall">
                        </div>
                    </div>
                </div>
                <div class="pos-activity-panel-message" style="margin-top:5px;text-align:center;font-size:120%;color:white"></div>
                <button class="command-btn cancel-btn" style="display:none"><i class="far fa-times" style="margin-right: 5px; pointer-events: none;"></i><span style="pointer-events: none;">Cancelar</span></button>
            </div>
        `
        this._cancelBtn = this.querySelector<HTMLButtonElement>(".cancel-btn")
        if (this._cancelBtn) {
            this._cancelBtn.onclick = this.handleClick
        }

        this._messageEl = this.querySelector<HTMLElement>(".pos-activity-panel-message")
        this.style.position = "absolute"
        this.style.left = "0"
        this.style.top = "0"
        this.style.right = "0"
        this.style.bottom = "0"
        this.style.background = "rgba(0,0,0,0.5)"
        this.style.zIndex = "1000"
        this.style.display = this._active ? "flex" : "none"
    }
    private _messageEl: HTMLElement | undefined | null
    private _cancelBtn: HTMLElement | undefined | null
    private _active = false
    private _timeout: any
    private _refCount = 0
    private _caption = ""
    private _transaction = ""
    set active(value: boolean) {
        if (this._active === value) return
        this._active = value
        const element = this.querySelector<HTMLElement>(".pos-activity-panel")
        this._active ? element?.removeAttribute("hidden") : element?.setAttribute("hidden", "")

        clearTimeout(this._timeout)
        this._timeout = setTimeout(() => {
            this.style.display = this._active ? "flex" : "none"
        }, value ? 500 : 50)
    }
    get active() {
        return this._active
    }

    handleClick = async (e: Event) => {
        if (!e.target) return
        if (this._cancelBtn?.style.cursor === "progress") return

        if (this._cancelBtn) this._cancelBtn.style.cursor = "progress"

        e.preventDefault()

        const result = (await Client.get<any>("WTSSYSTEM.TASKS.LIST", {})).value
        const tasks = result.filter(t => t.CURRENT_COMMAND == this._transaction &&
            t.USERNAME == millennium.browser.userName &&
            t.USERGROUP == millennium.browser.userGroup)
        for (let item of tasks)
            await Client.get<any>("WTSSYSTEM.TASKS.CANCEL", { REQUESTID: item.REQUESTID })

    }


    transaction(value: string) {
        this._transaction = value
        if (this._cancelBtn) {
            this._cancelBtn.style.display = ""
            this._cancelBtn.style.cursor = "pointer"
        }
    }

    begin() {
        this._refCount++
        if (this._refCount === 1) this.active = true
    }
    end() {
        this._refCount--
        if (this._refCount <= 0) this.active = false
    }
    get caption() {
        return this._caption
    }
    set caption(value: string) {
        this._caption = value
        if (this._messageEl) this._messageEl.innerText = value
    }
}

customElements.define("mln-activity-indicator", MlnActivityIndicator)
declare global {
    interface HTMLElementTagNameMap {
        "mln-activity-indicator": MlnActivityIndicator
    }
}

class MlnLogoImage extends HTMLElement {
    connectedCallback() {
        const shadow = this.attachShadow({ mode: "closed" })
        shadow.innerHTML = `
        <svg style="margin-bottom: 20px;width:100%;transform: translateX(20px)"
            xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            sodipodi:docname="linx_logo_big.svg" inkscape:version="1.0 (4035a4fb49, 2020-05-01)"
            id="svg1879" version="1.1" viewBox="0 0 34.660438 20.902091" height="79" width="131">
            <defs id="defs1873">
                <filter height="1.0359496" y="-0.01797482" width="1.0143387" x="-0.0071693626"
                    id="filter3476" style="color-interpolation-filters:sRGB" inkscape:collect="always">
                    <feGaussianBlur id="feGaussianBlur3478" stdDeviation="0.061897021"
                        inkscape:collect="always" />
                </filter>
                <linearGradient inkscape:collect="always" xlink:href="#linearGradient2345"
                    id="linearGradient1801" gradientUnits="userSpaceOnUse" x1="-51.486362" y1="-49.411762"
                    x2="-44.944973" y2="-42.781609" />
                <linearGradient id="linearGradient2345" inkscape:collect="always">
                    <stop id="stop2341" offset="0" style="stop-color:#ff6600;stop-opacity:1;" />
                    <stop id="stop2343" offset="1" style="stop-color:#fff900;stop-opacity:1" />
                </linearGradient>
                <linearGradient inkscape:collect="always" xlink:href="#linearGradient2375"
                    id="linearGradient1803" gradientUnits="userSpaceOnUse" x1="-48.758926" y1="-52.207962"
                    x2="-52.160717" y2="-50.129093" />
                <linearGradient id="linearGradient2375" inkscape:collect="always">
                    <stop id="stop2371" offset="0" style="stop-color:#ff6600;stop-opacity:1;" />
                    <stop id="stop2373" offset="1" style="stop-color:#ffec00;stop-opacity:1" />
                </linearGradient>
            </defs>
            <sodipodi:namedview inkscape:window-maximized="0" inkscape:window-y="160"
                inkscape:window-x="238" inkscape:window-height="1208" inkscape:window-width="1749"
                units="px" showgrid="false" inkscape:document-rotation="0" inkscape:current-layer="layer1"
                inkscape:document-units="mm" inkscape:cy="560" inkscape:cx="400" inkscape:zoom="0.35"
                inkscape:pageshadow="2" inkscape:pageopacity="0.0" borderopacity="1.0" bordercolor="#666666"
                pagecolor="var(--logo-text-color)" id="base" />                        
            <g id="layer1" inkscape:groupmode="layer" inkscape:label="Layer 1">
                <g transform="translate(58.869792,-14.741071)" id="g1837">
                    <g style="fill:var(--logo-text-color);stroke:#000000;stroke-width:0.264583;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                        transform="translate(7.5129406,72.452406)" id="g3496">
                        <g inkscape:export-ydpi="153.95" inkscape:export-xdpi="153.95"
                            inkscape:export-filename="c:\millennium\linx_login_hl.png"
                            style="opacity:1;fill:var(--logo-text-color);fill-opacity:1;stroke:none;stroke-width:0.264583;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;filter:url(#filter3476)"
                            transform="translate(-206.62709,26.26041)" id="g3058">
                            <g style="fill:var(--logo-text-color);fill-opacity:1;stroke:none;stroke-width:0.264583;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                                id="g3054">
                                <path id="path3044"
                                    d="m 142.19922,-72.902344 v 5.103516 c 0,0.513743 0.17155,1.212569 0.58984,1.832031 0.4183,0.619462 1.1221,1.147794 2.10156,1.158203 l 1.11133,0.01172 0.006,-0.666016 -1.10937,-0.01172 c -0.75362,-0.008 -1.22899,-0.375154 -1.5586,-0.863282 -0.32961,-0.488128 -0.47461,-1.108171 -0.47461,-1.460937 v -5.103516 z"
                                    style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-variant-east-asian:normal;font-feature-settings:normal;font-variation-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;shape-margin:0;inline-size:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:var(--logo-text-color);fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.264583;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate;stop-color:#000000;stop-opacity:1" />
                                <path sodipodi:nodetypes="ccccc" id="path3046"
                                    d="m 147.508,-70.841053 v 6.044164 h 0.76562 v -6.044164 c -0.29336,-0.155927 -0.53457,-0.09871 -0.76562,0 z"
                                    style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-variant-east-asian:normal;font-feature-settings:normal;font-variation-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;shape-margin:0;inline-size:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:var(--logo-text-color);fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.264583;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate;stop-color:#000000;stop-opacity:1" />
                                <circle r="0.46065846" cy="-72.394257" cx="147.91861" id="circle3048"
                                    style="opacity:1;fill:var(--logo-text-color);fill-opacity:1;stroke:none;stroke-width:0.264583;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
                                <path id="path3050"
                                    d="m 152.93359,-71.394531 c -1.23014,0.01308 -2.00246,0.632533 -2.4082,1.234375 -0.40573,0.601842 -0.49219,1.207031 -0.49219,1.207031 l -0.004,0.02734 v 4.128906 h 0.76367 v -4.054687 c 0.001,-0.0095 0.0675,-0.436353 0.36719,-0.88086 0.30218,-0.448237 0.79203,-0.881813 1.77734,-0.894531 0.9869,0.01205 1.47883,0.445934 1.78125,0.894531 0.29966,0.444502 0.36377,0.871401 0.36523,0.88086 v 4.054687 h 0.76563 v -4.128906 l -0.004,-0.02734 c 0,0 -0.0884,-0.60519 -0.49414,-1.207031 -0.40573,-0.601841 -1.17806,-1.221288 -2.4082,-1.234375 h -0.004 z"
                                    style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-variant-east-asian:normal;font-feature-settings:normal;font-variation-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;shape-margin:0;inline-size:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:var(--logo-text-color);fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.264583;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate;stop-color:#000000;stop-opacity:1" />
                                <path sodipodi:nodetypes="ccccc" id="path3052"
                                    d="m 157.95747,-71.443348 c -0.2962,0.06236 -0.52646,0.190383 -0.60255,0.471945 l 4.96225,6.333555 c 0.52954,-0.123382 0.48114,-0.322437 0.60256,-0.469991 z"
                                    style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-variant-east-asian:normal;font-feature-settings:normal;font-variation-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;shape-margin:0;inline-size:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:var(--logo-text-color);fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.264583;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate;stop-color:#000000;stop-opacity:1" />
                            </g>
                            <path sodipodi:nodetypes="ccccc" id="path3056"
                                d="m 162.31718,-71.443348 c 0.2962,0.06236 0.52646,0.190383 0.60255,0.471945 l -4.96225,6.333555 c -0.52954,-0.123382 -0.48114,-0.322437 -0.60256,-0.469991 z"
                                style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-variant-east-asian:normal;font-feature-settings:normal;font-variation-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;shape-margin:0;inline-size:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:var(--logo-text-color);fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.264583;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate;stop-color:#000000;stop-opacity:1" />
                        </g>
                    </g>
                    <g transform="matrix(0.84592226,0,0,0.84592226,11.08045,63.361058)"
                        inkscape:export-ydpi="298.42001" inkscape:export-xdpi="298.42001"
                        inkscape:export-filename="z:\wdts\client\browser\linx_ico.png" id="g4840">
                        <rect inkscape:export-ydpi="47.33268" inkscape:export-xdpi="47.33268" y="-55.48473"
                            x="-56.597893" height="12.819356" width="12.87905" id="rect4830"
                            style="fill:none;stroke:none;stroke-width:0.224234" />
                        <path inkscape:export-ydpi="47.33268" inkscape:export-xdpi="47.33268"
                            sodipodi:nodetypes="ccczccscc" id="path4832"
                            d="m -47.059708,-54.36198 -7.53366,9.18739 c -1.00457,1.323422 -0.383766,1.9512 0.451018,1.603616 0,0 2.470001,-1.055169 4.025745,-1.102487 1.555745,-0.04732 4.510175,1.135897 4.510175,1.135897 0.668178,0.0975 0.413203,-0.689336 0.183747,-0.985557 -0.231617,-0.772058 -4.164723,-3.763548 -3.858703,-4.827554 0.319215,-1.109882 1.995668,-2.748591 2.555764,-3.975636 0.631063,-0.930795 0.790497,-2.430801 -0.334086,-1.035669 z"
                            style="fill:url(#linearGradient1801);fill-opacity:1;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                        <path inkscape:export-ydpi="47.33268" inkscape:export-xdpi="47.33268"
                            sodipodi:nodetypes="cszsc" id="path4834"
                            d="m -51.061139,-49.459008 c -0.02169,0.07049 -2.183642,-1.51605 -1.46998,-2.088042 0.279858,-0.224303 1.166803,0.269716 2.288494,-0.317386 1.121691,-0.587101 2.288496,-1.520093 2.722809,-1.920997 0.139951,-0.129186 -3.541323,4.326425 -3.541323,4.326425 z"
                            style="fill:url(#linearGradient1803);fill-opacity:1;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                        <rect style="fill:none;stroke:none;stroke-width:0.224234" id="rect4836"
                            width="12.87905" height="12.819356" x="-56.597893" y="-55.48473"
                            inkscape:export-xdpi="47.33268" inkscape:export-ydpi="47.33268" />
                        <path
                            style="fill:#ff6600;fill-opacity:0;stroke:none;stroke-width:0.264583px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                            d="m -47.059708,-54.36198 -7.53366,9.18739 c -1.00457,1.323422 -0.383766,1.9512 0.451018,1.603616 0,0 2.470001,-1.055169 4.025745,-1.102487 1.555745,-0.04732 4.510175,1.135897 4.510175,1.135897 0.668178,0.0975 0.413203,-0.689336 0.183747,-0.985557 -0.231617,-0.772058 -4.164723,-3.763548 -3.858703,-4.827554 0.319215,-1.109882 1.995668,-2.748591 2.555764,-3.975636 0.631063,-0.930795 0.790497,-2.430801 -0.334086,-1.035669 z"
                            id="path4838" sodipodi:nodetypes="ccczccscc" inkscape:export-xdpi="47.33268"
                            inkscape:export-ydpi="47.33268" />
                    </g>
                </g>
            </g>
        </svg>
        `
    }
}

customElements.define("mln-logo-image", MlnLogoImage)

const FRAMES = Symbol("FRAMES")

export class MillenniumBrowser extends HTMLElement implements IMillenniumBrowser {

    [FRAMES]: Set<MillenniumFrame> = new Set()

    hasFrame(key: string): boolean {
        for (const frame of this[FRAMES])
            if (frame.key === key)
                return true

        return false
    }
    getVersionInfo(): PromiseLike<string> {
        throw new Error("Method not implemented.")
    }
    session = getDefaultSession();
    get onAuthFail(): EventEmitter { return this.session.onAuthFail }
    get onLoginDone(): EventEmitter { return this.session.onLoginDone }

    lastNotificationTime?: number
    lastNotificationMsg?: string
    isEmbedded = false;
    win_activate() {
        const module = $(".mln-content-frame.visible").data("mln-module-instance")
        if (module) void module.activate?.()
    }
    win_notify(message: string, type: "warning" | "danger" | "success" | "warning-auto-hide") {
        $('.top-right').notify({
            message: { html: message },
            type: type,
            fadeOut: {
                delay: 10000
            }
        }).show()
    }
    notify(message: string | Error, type: "warning" | "danger" | "success" | "warning-auto-hide") {
        let msgText = typeof message === "string" ? message : message.message
        if (msgText.startsWith("Remote Call Error")) {
            console.error(msgText)
            if (msgText.includes(String.fromCharCode(13)))
                msgText = msgText.slice(msgText.indexOf(String.fromCharCode(13)) + 2)
        }

        if (Date.now() - (this.lastNotificationTime ?? 0) > 5000 || this.lastNotificationMsg !== msgText) {
            this.lastNotificationMsg = msgText
            this.lastNotificationTime = Date.now()
            this.win_notify(msgText, type)
        }
    }
    async switchUser(): Promise<void> {
        const defSession = this.session
        await defSession.logout(true)
        const newSession = new Session()

        let loginInfo
        do {
            loginInfo = await showLogin({ blank: true, message: "Entre com um usuário do grupo " + defSession.userGroup, canCancel: false })

            if (loginInfo) {
                try {
                    await newSession.login(this.session.appName, this.session.licenceName, this.session.host, loginInfo.username, loginInfo.password)
                    if (newSession.userGroup !== defSession.userGroup) {
                        await newSession.logout()
                        throw Error("O usuário deve ser do grupo " + defSession.userGroup)
                    }
                } catch (e: any) {
                    this.notify(e, "warning")
                    loginInfo = undefined
                }
            }
        } while (!loginInfo)

        newSession.onAuthFail.assign(defSession.onAuthFail)
        newSession.onLoginDone.assign(defSession.onLoginDone)
        newSession.isDefault = true
        this.session = newSession

        defSession.destroy()

        this.loginDone()
    }
    msgBox(message: string, title: string, flags: number): Promise<number> {
        const dialog = new CommandDialogWindow()

        const msg = document.createElement("div")
        msg.innerText = message
        msg.style.textAlign = "center"
        msg.style.padding = "30px"
        msg.style.fontSize = "110%"
        msg.style.display = "flex"
        msg.style.alignItems = "center"
        msg.style.justifyContent = "center"

        let commands: DialogWindowCommand[] = []

        if (flags & MsgBoxFlags.MB_OK || flags === 0)
            commands = [{ caption: "OK", id: MsgBoxResult.IDOK }]
        else if (flags & MsgBoxFlags.MB_OKCANCEL)
            commands = [{ caption: "OK", id: MsgBoxResult.IDOK }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]
        else if (flags & MsgBoxFlags.MB_YESNO)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Não", id: MsgBoxResult.IDNO }]
        else if (flags & MsgBoxFlags.MB_YESNOCANCEL)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Não", id: MsgBoxResult.IDNO }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]
        else if (flags & MsgBoxFlags.MB_RETRYCANCEL)
            commands = [{ caption: "Sim", id: MsgBoxResult.IDYES }, { caption: "Retentar", id: MsgBoxResult.IDRETRY }, { caption: "Cancelar", id: MsgBoxResult.IDCANCEL }]

        return dialog.show(msg, {
            title,
            commands,
            width: "fit-content",
            height: "fit-content",
            minWidth: "320px",
            minHeight: "160px",
            commandBarStyle: "clear"
        })
    }
    //frame callbacks
    frame_navigateSc = (frame: IMillenniumFrame | undefined, key: string, data: string, vars: Object, caption?: any) => {
        return this.load(undefined/*force new tab*/, key, undefined, vars)
    };
    frame_navigate = (frame: IMillenniumFrame | undefined, data: string, vars: Object) => {
        return this.load(undefined/*force new tab*/, "", data, vars)
    };
    frame_close = (frame: IMillenniumFrame) => { };
    frame_setCaption = (frame: IMillenniumFrame, value: string) => { };
    frame_setUrl = (frame: IMillenniumFrame, value: string) => { };
    frame_activity = (frame: IMillenniumFrame, value: string) => { };
    frame_activate = (frame: IMillenniumFrame) => { };
    frame_notify = (frame: IMillenniumFrame, message: string, type: string) => { };
    frame_initialized = () => { };
    frame_create: () => IMillenniumFrame = () => new MillenniumFrame(this);
    createFrame(): IMillenniumFrame {
        return this.frame_create()
    }
    async createFrameAsNative() {
        const handle = await this.createNativeFrame()
        return new NativeFrame(this, handle)
    }
    private rootRoutes?: IRoute[]
    async getVersion() {
        if (this.isEmbedded)
            return {}
        else {
            return {
                "millennium": await this.getVersionInfoMillennium(),
                "omni": await this.getVersionInfoOmnichannel()
            }
        }
    }
    async getObjectActions(objectName: string): Promise<ICommand[]> {
        //todo: read from api
        return []
    }
    async getRoutes(session: Session = this.session) {
        let routes: (IRoute & {
            id: string,
            appname?: string
        })[] = []

        try {
            routes = await Client.getJSON<any>("./millennium.routes.json")
        }
        catch { }

        const acl = await Client.getJSON<(IRoute & {
            id: string
        })[]>(session.host + "/api/routes", { appname: session.appName, moduleType: "html" }, session)

        if (routes) {

            const clientRoutes = routes.filter(e => e.appname === session.appName).map(e => {
                return { ...e, id: e.urlKey, key: e.urlKey, _client: true, _preloaded: true }
            })

            const adjustedRoutes = []
            for (let route of routes) {
                if (acl.findIndex(e => e.key === route.urlKey) >= 0 || route.urlKey === "start") {
                    route["id"] = route.urlKey
                    route["key"] = route.urlKey;
                    (route as any)["_preloaded"] = true
                    adjustedRoutes.push(route)
                }
            }
            routes = [...clientRoutes, ...(adjustedRoutes.length ? adjustedRoutes : acl)]
        }
        else
            routes = acl

        /*for (const route of routes)
            if (route.text && !route.icon) {
                route.icon = route.text.toLowerCase().replaceAll(" ", "_");
            }*/

        this.rootRoutes = routes
        return routes
    }
    async getRoute(key: string, data?: string, session: Session = this.session): Promise<IRoute> {

        if (key.startsWith("$"))
            return {
                target: key.slice(1).toLocaleLowerCase(),
                text: "",
                urlKey: key,
                icon: ""
            }

        let cachedRoute: IRoute | undefined
        if (session === this.session && this.rootRoutes) {
            cachedRoute = this.rootRoutes.find(e => (e.urlKey || e.key || "").toLowerCase() === (key || data || "").toLowerCase())
            if (cachedRoute && cachedRoute.target)
                return Promise.resolve(cachedRoute)
        }
        const route = await Client.getJSON<IRoute>(session.host + "/api/routes", { key: key || "", data: data || "" }, session)
        if (!cachedRoute && this.rootRoutes) {
            cachedRoute = { key } as IRoute
            this.rootRoutes.push(cachedRoute)
        }
        for (let k in route)
            (cachedRoute as any)[k] = (route as any)[k]

        if (cachedRoute && cachedRoute.target === "")
            cachedRoute.target = "_"

        if (key === "" && cachedRoute)
            cachedRoute.urlKey = data || ""

        // Cache-MISS deve retornar a rota ENRIQUECIDA (cachedRoute), não a resposta crua do
        // servidor. A resposta do /api/routes traz o `target` mas NÃO o `text`/caption amigável;
        // o `text` vem do menu e já está no cachedRoute. Retornar `route` cru fazia a 1ª
        // abertura ficar sem título (só o cache-HIT — 2ª abertura — retornava o cachedRoute
        // com `text`). Igualar ao cache-HIT corrige a assimetria "2ª vez tem título, 1ª não".
        // (porte da master c9482cf61d1)
        return cachedRoute ?? route
    }
    get inLogin() {
        return this.session.inLogin
    }
    showUserInfo() {
        function getGravatarImage(email: string, args?: any) {
            args = args || ""
            var BASE_URL = "https://www.gravatar.com/avatar/"
            return (BASE_URL + ((email) ? (Md5.hashStr(email.toLowerCase().trim()) + "?") : "?d=mm&") + args).trim()
        }
        if (!this.isEmbedded) {
            try {
                $("#usr-img").attr("src", getGravatarImage(this.session.getLoggedUserInfo().employeeEmail || this.session.getLoggedUserInfo().employeeName, "s=28"))
            } catch (error: any) {
                this.notify(error, "warning")
            }
            $("#employee-name").text(this.userName)
        }
    }
    loginDone() {
        this.session.isDefault = true
        this.showUserInfo()
        this.session.loginDone()
        if (this.onLoginDone)
            this.onLoginDone.trigger()
    }
    async login(appName: string, licenceName: string, host: string, userName: string, passWord: string) {
        const sessionData = await this.session.login(appName, licenceName, host, userName, passWord)

        this.loginDone()

        return sessionData
    }

    accessList = new Map<string, Set<string>>();
    async hasAccess(key: string, session?: Session): Promise<boolean> {
        if (!session) session = getDefaultSession()

        const mapKey = `${key}`
        let accessList = this.accessList.get(session.id)

        if (!accessList) {

            //don´t filter appname, because some permitions are shared between apps (ag: omni & millennium)
            const aclArray = await Client.getJSON<string[] | { key: string }[]>(this.session.host + "/api/routes", { grants: "true", appname: "" }, session)

            accessList = new Set()
            for (const item of aclArray) {
                if (typeof item === "string") {
                    accessList.add(item)
                }
                else
                    accessList.add(item.key)
            }

            this.accessList.set(session.id, accessList)
        }

        return accessList.has(mapKey)
    }

    async hasPermission(key: string, session?: Session): Promise<boolean> {
        if (!session) session = getDefaultSession()

        const mapKey = `${key}`
        let accessList = this.accessList.get(session.id)

        if (!accessList) {

            //don´t filter appname, because some permitions are shared between apps (ag: omni & millennium)
            const aclArray = await Client.getJSON<string[] | { key: string }[]>(this.session.host + "/api/routes", { grants: "true", appname: "" }, session)

            accessList = new Set()
            for (const item of aclArray) {
                if (typeof item === "string") {
                    accessList.add(item)
                }
                else
                    accessList.add(item.key)
            }

            this.accessList.set(session.id, accessList)
        }

        return accessList.has(mapKey)
    }

    async accessPrompt(message: string, key: string, userInfo?: any): Promise<boolean> {
        if (userInfo) userInfo.username = this.userName

        let access
        try {
            access = await this.hasAccess(key)
        } catch { }

        if (access)
            return access
        else {

            const loginInput = await showLogin({ message, canCancel: true, blank: true })

            const session = new Session()
            try {
                if (!loginInput) return false
                await session.login(this.session.appName, this.session.licenceName, this.session.host, loginInput.username, loginInput.password, [key])
                if (userInfo) userInfo.username = loginInput.username

                return true
            } catch (e: any) {
                return false
            } finally {
                session.destroy()
            }
        }
    }
    async logout() {
        if (this.session.isActive())
            await this.session.logout()
    }
    async decodeRoute(routeKey: string, routeObj: any, vars?: any): Promise<IRoute> {
        if (!routeKey) {
            routeObj = await this.getRoute(routeKey, routeObj)
        } else if (routeKey && !routeObj)
            routeObj = await this.getRoute(routeKey)
        else {
            if ((routeObj as any)["_preloaded"]) {
                const route = await this.getRoute(routeKey)
                routeObj = { ...routeObj, ...route }
            } else
                routeObj = await this.getRoute(routeKey)
        }

        if (vars && routeObj.params) {
            const params = []
            for (const param of routeObj.params) {
                const item = { ...param }
                for (let key in item)
                    if (typeof item[key] === "string" && item[key].startsWith("{$")) {
                        let varName = item[key].trim().slice(2, -1)
                        if (varName.endsWith("[]")) varName = varName.slice(0, -2)
                        item[key] = vars[varName]
                    }

                params.push(item)
            }
            routeObj = { ...routeObj, params }
        }

        return routeObj
    }
    async getVersionInfoOmnichannel(): Promise<string> {
        try {
            const value = await Client.getJSON<any>("chcp.json")
            return value && value.release
        } catch {
            return ""
        }
    }
    async getVersionInfoMillennium(): Promise<string> {
        try {
            const text = await Client.getText(getCurrentHost() + "/files/apps/installedpacks/{8AD628CF-4B83-4A72-8A50-C6835E946B52}.inf")
            return text.split('\r\n').filter(e => e.startsWith("Version"))[0].split("=")[1]
        } catch {
            return ""
        }
    }
    afterLoad?: () => void
    async getSessionId(): Promise<string> {
        return this.session?.id
    }
    navigate(place: string, vars: Object): Promise<void> {
        return this.frame_navigate(undefined, place, vars)
    }
    navigateSc(key: string, data: string, vars: Object, caption?: any): Promise<void> {
        return this.frame_navigateSc(undefined, key, data, vars, caption)
    };
    async load(frame: IMillenniumFrame | undefined, routeKey: string, route?: IRoute | string, vars?: any): Promise<any> {
        return LoadIndicator(document.body, this.internalLoad({ frame, routeKey, route, vars }))
    }

    #currentModuleName = ""
    get currentModuleName() {
        return this.#currentModuleName
    }
    set currentModuleName(name: string) {
        for (const frame of this[FRAMES])
            frame.visible = frame.moduleName === name
        this.#currentModuleName = name
    }

    /**
     * Desfaz o vínculo de "módulo ativo" quando a última aba visível de um
     * workspace é fechada (sem irmã do mesmo módulo para assumir).
     *
     * Sem isto, `#currentModuleName` fica preso no módulo recém-fechado e o guard
     * `if (this.currentModuleName === moduleName) return` em showModule aborta a
     * REABERTURA do MESMO link — que só volta a carregar depois de o usuário
     * visitar outro módulo e retornar (esse caminho passa pelo setter de
     * currentModuleName). Zerar o estado aqui (sem passar pelo setter, evitando
     * efeitos colaterais de visibilidade) faz a reabertura seguir exatamente o
     * mesmo caminho da troca de módulos. (porte da master c9482cf61d1)
     */
    resetActiveModule() {
        this.#currentModuleName = ""
    }

    async internalLoad({ frame, routeKey, route, vars }: { frame: IMillenniumFrame | undefined; routeKey: string; route?: IRoute | string; vars?: any }): Promise<any> {
        try {
            try {

                let params: any
                let url = ""
                if ((typeof route === "object" && (route.target || route.urlKey))) {//the route came ready from the host, like in embeded use case
                    params = route
                    routeKey = routeKey || route?.target || route?.urlKey || ""
                } else {//here we just have the key, need to load route details
                    url = window.location.pathname + "#/" + (routeKey || (typeof route === "string" ? route : undefined) || "").toLowerCase() + ((vars instanceof Object) ? "/" + JSON.stringify(vars) : "")
                    params = await this.decodeRoute(routeKey, route, vars)
                }

                let frameLocation = ""

                var moduleName = params.target

                if (!moduleName) return

                if (moduleName.indexOf(",") > 0)
                    [frameLocation, moduleName] = moduleName.split(",")
                if (moduleName.substr(-5).toLowerCase() === ".html")
                    moduleName = moduleName.slice(0, -5)
                if (moduleName.charAt(0) === '#')
                    moduleName = moduleName.slice(1)

                if ((frameLocation === "_blank" || !frame) && frame?.element.childElementCount !== 0)
                    frame = this.frame_create()
                //module loader
                $(frame.element).attr("id", params.target)

                const validKeys = ["caption"]
                const paramCaption = (params?.params as any[])?.find(e => validKeys.indexOf(e["@type"]) !== -1)
                let caption = params?.caption || params?.text || paramCaption?.caption || ""
                // Fallback do título quando a rota chega sem caption/text (ex.: URL "#/rota" digitada
                // à mão): deriva do texto do menu (`_routes`), que é o que a sidebar renderiza.
                // No embedded (binbrowser) não atua (`_routes` vazio) — o caption vem da URL.
                // (porte da master c9482cf61d1)
                if (!caption)
                    caption = this.captionFromMenu(routeKey || params?.target || params?.urlKey || "")
                frame.setCaption(caption)
                frame.setUrl(url)
                frame.moduleName = this.#currentModuleName
                frame.key = routeKey

                let { moduleClass, htmlTemplate, cssTemplate } = await loadModule(moduleName)

                if (cssTemplate && typeof cssTemplate !== "object") {
                    let tmpStyle = $("<div>").append("<style>")
                    tmpStyle.children().text(cssTemplate.replace(/\n/g, ''))
                    htmlTemplate = "<style>" + cssTemplate + $(tmpStyle).children(".css-finalized").text() + "</style>" + htmlTemplate
                }

                var module = (moduleClass.default) ? new moduleClass.default() : new moduleClass()

                try {
                    $(frame.element).data("mln-frame-instance", frame)
                    if (!module.bind) {
                        $(htmlTemplate).appendTo(frame.element)
                        if (module.onInit)
                            await module.onInit(frame, params)
                    }
                    else
                        await module.bind(frame, params, htmlTemplate)

                } catch (e: any) {
                    this.notify("Erro carregando módulo: " + ((e instanceof Error) ? e.message : e.toString()), "danger")
                    if (e instanceof Error) console.error(e.message, e.stack)
                    return
                }

                $(frame.element).data("mln-module-instance", module)

                await frame.activate()
                window.dispatchEvent(new Event("resize"))

                $(frame.element).addClass("activated")

                //only ok after session joint
                this.frame_activate(frame)
            } finally {
                if (this.afterLoad)
                    this.afterLoad()
            }
        } catch (error: any) {
            this.notify(error, "danger")
            frame?.close()
        }
    }

    get userName(): string {
        return this.session.userName
    }
    get userGroup(): string {
        return this.session.userGroup
    }
    get wsid(): string {
        return this.session.wsid
    }

    async joinSession(host: string, sessionId: string, sessionData: any, joinOnServer: boolean, appName?: string) {
        try {
            await this.session.joinSession(host, sessionId, sessionData, joinOnServer, appName)
            this.loginDone()
        } catch (e) {
            if (this.onLoginDone)
                this.onLoginDone.trigger()
            throw e
        }
    }

    loginError() {
        this.notify("Não autenticado", "danger")
    }
    getData(dataType: string, callback: (data: string) => void) {
        callback('')
    }
    private handleWindowMessage = (e: MessageEvent) => {
        if (e.origin !== location.origin) return
        this.broadcastRecv(e.data.name, e.data.data)
    }
    private _subscriptions = new Map<string, { callbacks: any[], id: number }>();
    broadcastRecv = (subject: string, data: string) => {
        const subs = this._subscriptions.get(subject)
        if (subs)
            for (const sub of subs.callbacks)
                sub(JSON.parse(data))
    }
    broadcast(name: string, data: any) {
        window.postMessage({ name, data: JSON.stringify(data) }, location.origin)
    }
    subscribeRemove(subject: string, callback: (data: any) => void) {
        let subs = this._subscriptions.get(subject.toUpperCase())
        if (subs) {
            const idx = subs.callbacks.findIndex(e => e === callback)
            if (idx >= 0) subs.callbacks.splice(idx, 1)
            if (subs.callbacks.length === 0) {
                this.win_subscribeRemove(subject, subs.id)
                this._subscriptions.delete(subject)
            }
        }
    }
    subscribeAdd(subject: string, callback: (data: any) => void) {
        let subs = this._subscriptions.get(subject.toUpperCase())
        if (!subs) {
            const subHandle = this.win_subscribeAdd(subject.toUpperCase(), this.broadcastRecv)
            subs = { callbacks: [], id: subHandle }
            this._subscriptions.set(subject, subs)
        }
        subs.callbacks.push(callback)
    }
    private win_subscribeAdd(subject: string, callback: (subject: string, data: any) => void): number {
        return -1
    }
    private win_subscribeRemove(subject: string, handle: number) {
    }
    initialize() {
    }
    printPDF(pdfAsBlob: Blob): void {
        var blobPdf = new Blob([pdfAsBlob], { type: 'application/pdf' })
        var blobURL = URL.createObjectURL(blobPdf)

        const iframe = document.createElement('iframe')
        document.body.appendChild(iframe)

        iframe.style.display = 'none'
        iframe.src = blobURL
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus()
                iframe.contentWindow?.print()
            }, 1)
        }
    }
    savePDF(pdfAsBlob: Blob): void {
        const blob = new Blob([pdfAsBlob], { type: "application/pdf" })
        const link = document.createElement("a")
        const href = window.URL.createObjectURL(blob)

        link.download = `${new Date().getTime()}.pdf`
        link.href = href
        link.click()
    }
    saveFile(fileAsBlob: Blob, aType: string, fileName: string): void {
        const blob = new Blob([fileAsBlob], { type: aType })
        const link = document.createElement("a")
        const href = window.URL.createObjectURL(blob)

        link.download = fileName
        link.href = href
        link.click()
    }

    async loadExtension(name: string) {
        return loadExtension(name + (!name.startsWith("http") && !name.endsWith(".mjs") ? ".js" : ""))
    }
    constructor() {
        super()
        window.addEventListener("message", this.handleWindowMessage)
    }
    createModal(content: HTMLElement, options: IModalWindowOptions): IModalWindow {
        const dialog = new CommandDialogWindow()
        return {
            close: (result) => dialog.close(result),
            show: () => dialog.show(content, options)
        }
    }
    destroy() {
        window.removeEventListener("message", this.handleWindowMessage)
    }
    createNativeFrame(): Promise<number> {
        throw Error("not implemented")
    };
    resizeNativeFrame(frameHandle: number, left: number, top: number, width: number, height: number, visible: number): void {
        throw Error("not implemented")
    };
    navigateNativeFrame(frameHandle: number, place: string): void {
        throw Error("not implemented")
    };
    destroyNativeFrame(frameHandle: number): void {
        throw Error("not implemented")
    };

    private notifiersList: (INotificationSource & { currentCount: number, currentList: INotificationItem[] })[] = []
    private keepAliveInterval: any
    private _routes: IRoute[] = []
    private _moduleRoutes: IRoute[] = []
    private _startupUrl: string = ""
    private activeSubmenu: Menu | undefined
    private currentLoginCallback: ((host: string, userName: string, password: string) => Promise<void>) | undefined
    private _searchTimeout: any

    connectedCallback() {
        if (this.childElementCount === 0) {
            this.innerHTML = browserHtmlTemplate
            this.start()
        }
    }

    private handleSidebarMouseDown(e: Event) {
        const sidebar = this.querySelector('#sidebar')
        if (sidebar && !sidebar.contains(e.target as Node)) {
            this.hideSideBar()
        }
    }

    private showSideBar() {
        const sidebar = this.querySelector<HTMLElement>('#sidebar')
        if (sidebar) {
            sidebar.style.display = "flex"
            setTimeout(() => {
                if (sidebar)
                    sidebar.style.transform = "translateX(0)"
                const searchBox = this.querySelector<HTMLInputElement>('#sidebar .search-box')
                if (searchBox && !Capacitor.isNativePlatform())
                    searchBox.focus()
            }, 50)
        }
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        if (dimmer)
            dimmer.classList.add('dimmer-show')
        window.addEventListener("mousedown", (e) => this.handleSidebarMouseDown(e))
        window.addEventListener("touchstart", (e) => this.handleSidebarMouseDown(e))
    }

    private hideSideBar(callback?: () => void) {
        window.removeEventListener("mousedown", this.handleSidebarMouseDown)
        window.removeEventListener("touchstart", this.handleSidebarMouseDown)
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        if (dimmer && dimmer.classList.contains("dimmer-show")) {
            const sidebar = this.querySelector<HTMLElement>('#sidebar')
            if (sidebar) {
                sidebar.style.transform = "translateX(-102%)"
                if (callback) {
                    sidebar.addEventListener("transitionend", function (e) {
                        if (callback && typeof callback === "function") callback()
                        callback = undefined
                    }, { once: true })
                }
            }
            dimmer.classList.remove('dimmer-show')
        }
    }

    private adjustPreloader() {
        const preloader = this.querySelector<HTMLElement>('#preloader')
        if (preloader && preloader.style.display !== "none") {
            preloader.style.marginLeft = `${((window.innerWidth ?? 0) - (preloader.offsetWidth ?? 0)) / 2}px`
            preloader.style.marginTop = `${((window.innerHeight ?? 0) - (preloader.offsetHeight ?? 0)) / 2}px`
        }
    }

    private showPreloader(value: boolean) {
        const dimmer = this.querySelector<HTMLElement>('.dimmer')
        const preloader = this.querySelector<HTMLElement>('#preloader')
        if (value) {
            if (dimmer)
                dimmer.classList.add('dimmer-show')
            if (preloader) {
                preloader.classList.add("windows8")
                preloader.style.display = "block"
                this.adjustPreloader()
            }
        }
        else {
            if (dimmer)
                dimmer.classList.remove('dimmer-show')
            if (preloader) {
                preloader.style.display = "none"
                preloader.classList.remove("windows8")
            }
        }
    }

    private updateNotificationCount(notifier: INotificationSource & { currentCount?: number, currentList?: INotificationItem[] }, result: INotificationItem[]) {

        for (const item of result) {
            const found = notifier.currentList && notifier.currentList.find(e => e.key === item.key)
            if (!found) {
                this.notify(item.description, "warning")
            }
        }

        notifier.currentList = result
        notifier.currentCount = result.reduce((count, next) => count + 1, 0)

        const el = document.getElementById("notification_count")
        if (el) el.textContent = this.notifiersList.reduce((sum, next) => sum + next.currentCount, 0).toString()

        localStorage.setItem("last-notify-" + notifier.name, JSON.stringify(result))
    }

    private async startNotifications() {
        const notifiers = await loadNotifiers()
        for (const notifier of notifiers) {
            type INotificationSourceEx = INotificationSource & {
                currentCount: number
                currentList: INotificationItem[]
            }

            const instance = notifier.Notifier as INotificationSourceEx

            const curListJSON = localStorage.getItem("last-notify-" + instance.name)
            if (curListJSON) instance.currentList = JSON.parse(curListJSON)
            this.notifiersList.push(instance)

            instance.subscribe((result) => this.updateNotificationCount(instance, (result as INotificationSourceEx).currentList))
        }
    }

    private keepAlive() {
        void Client.get("wtssystem/system/now")
    }

    private async handleMenuItemClick(event: Event) {
        if (!(event.target instanceof HTMLElement)) return

        if (event.target.classList.contains("menu-item_active")) {
            event.stopImmediatePropagation()
            event.preventDefault()
            return
        }

        event.target.classList.add("menu-item_active")

        this.activeSubmenu?.close() //we can´t await so the activeSubmenu don´t get overriten by another event
        this.activeSubmenu = new Menu()
        const route = await this.activeSubmenu.show<IRoute | undefined | number>(event.target, (event.target as any)["MENU_ITEMS"] ?? [])
        event.target.classList.remove("menu-item_active")

        if (route && typeof route === "object")
            this.loadRoute(route)
    }

    private showMenu(moduleName: string, routes: IRoute[]) {
        const menuBar = this.querySelector(".menu-bar")
        if (!menuBar) return
        menuBar.innerHTML = ""

        if (!this._routes.find(e => e.nodes?.length)) {
            return
        }

        let mainMenu: HTMLElement & { ["MENU_ITEMS"]?: IRoute[] } | undefined
        for (const route of routes) {
            if (route.nodes?.length) {
                const item = document.createElement("div") as HTMLElement & { ["MENU_ITEMS"]?: IRoute[] }
                item.innerText = route.text
                item.className = "menu-item"
                item.onpointerdown = (e) => this.handleMenuItemClick(e)
                item.onmouseenter = (e) => this.handleMenuItemClick(e)
                item["MENU_ITEMS"] = route.nodes
                menuBar.appendChild(item)
            } else {
                if (!mainMenu) {
                    mainMenu = document.createElement("div") as HTMLElement & { ["MENU_ITEMS"]?: IRoute[] }
                    mainMenu.className = "menu-item"
                    mainMenu.innerText = moduleName || "Geral"
                    mainMenu.onpointerdown = (e) => this.handleMenuItemClick(e)
                    mainMenu.onmouseenter = (e) => this.handleMenuItemClick(e)
                    mainMenu["MENU_ITEMS"] = []

                    if (menuBar.firstElementChild)
                        menuBar.firstElementChild.insertAdjacentElement("beforebegin", mainMenu)
                    else
                        menuBar.appendChild(mainMenu)
                }
                mainMenu["MENU_ITEMS"]?.push(route)
            }
        }
    }

    private async showModule(moduleName: string) {

        if (this.currentModuleName === moduleName) return

        const menuPanel = this.querySelector(".side-module-selector")

        if (menuPanel)
            menuPanel.querySelectorAll(".menu-side-item").forEach(e => {
                if (e.getAttribute("data-menu") === moduleName)
                    e.classList.add("active")
                else
                    e.classList.remove("active")
            })

        this._moduleRoutes = this._routes.flatMap(e => {
            return ((e.text === moduleName) ? e.nodes : e.nodes === undefined ? e : undefined) ?? []
        })
        this.showMenu(moduleName, this._moduleRoutes)
        this.currentModuleName = moduleName
        const homeRoute = this._moduleRoutes.find(e => e.text?.indexOf("Portal") > -1)
        if (homeRoute && homeRoute.key && !this.hasFrame(homeRoute.key))
            await this.loadRoute(homeRoute)

        return homeRoute
    }

    private handleSidePanelClick(e: Event) {
        if (!e.target || !(e.target instanceof HTMLElement)) return
        this.showModule(e.target.getAttribute("data-menu") ?? "")
    }

    private buildModulePanel() {

        const moduleSelector = this.querySelector<HTMLElement>(".side-module-selector")
        if (moduleSelector) {
            moduleSelector.innerHTML = ""
            moduleSelector.style.display = ""
        }

        if (!this._routes.find(e => e.nodes?.length)) {
            if (moduleSelector)
                moduleSelector.style.display = "none"
            return
        }

        const createModuleItem = (route: IRoute | { text: string }, targetModule?: string, active = false) => {
            const item = document.createElement("button")
            item.title = route.text
            item.className = "menu-side-item"
            const icon = document.createElement("img")
            icon.src = "images/" + route.text.toLowerCase().normalize("NFD").replace(/[̀-]/g, "").replaceAll(" ", "_") + ".svg"
            icon.onerror = (e) => { checkShowPanel(); if (e instanceof Event) (e.target as HTMLImageElement).src = "images/generic.svg" }
            icon.onload = (_) => { checkShowPanel() }
            item.appendChild(icon)
            const text = document.createElement("label")
            text.innerText = route.text
            item.onclick = (e) => this.handleSidePanelClick(e)
            item.setAttribute("data-menu", targetModule ?? route.text)
            item.appendChild(text)
            if (active) item.classList.add("active")
            return item
        }

        let itemCount = 1
        if (this._routes.length) {
            if (moduleSelector)
                moduleSelector.appendChild(createModuleItem({
                    text: "Home"
                }, "", true))
        }
        for (const route of this._routes)
            if (route.nodes?.length) {
                itemCount++
                if (moduleSelector)
                    moduleSelector.appendChild(createModuleItem(route))
                //menuPanel?.appendChild(createItem())
            }

        //show when all images are loaded
        const checkShowPanel = () => {
            itemCount--
            if (itemCount === 0)
                setTimeout(() => moduleSelector?.classList.add("side-module-selector_ready"), 50)
        }

        //or when there is a timeout
        setTimeout(() => moduleSelector?.classList.add("side-module-selector_ready"), 500)
    }

    private async loginSuccess() {
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.blur()

        const navTreeContainer = this.querySelector<HTMLElement>('.sidebar .menu-tree-area')
        if (navTreeContainer)
            navTreeContainer.innerHTML = ""

        const licenceType = this.querySelector<HTMLSelectElement>("#licence_type")
        if (licenceType)
            licenceType.disabled = true

        if (!this.isEmbedded) {
            try {
                const versions = await this.getVersion()
                const versionOmni = this.querySelector(".versionOmnichannel")
                if (versionOmni)
                    versionOmni.textContent = versions["omni"] ?? ""
                const versionMillennium = this.querySelector(".versionMillennium")
                if (versionMillennium)
                    versionMillennium.textContent = versions["millennium"] ?? ""
            } catch { }

            this._routes = await this.getRoutes()
            const sidebar = this.querySelector<HTMLElement>('#sidebar')
            if (sidebar)
                sidebar.style.display = "none"

            this.buildModulePanel()

            if (navTreeContainer) {
                const navTree = document.createElement("mln-treeview") as MlnTreeView;
                navTree.className = "menu-tree"
                navTree.onhoverColor = "rgba(255,255,255,0.3)"
                navTree.selectedBackColor = "var(--accent-color)"
                navTree.collapseIcon = "far fa-chevron-down"
                navTree.expandIcon = "far fa-chevron-right"
                navTree.levels = 1
                navTree.treeData = this._routes;
                navTree.addEventListener("nodeSelected", (e) => {
                    this.nodeSelected(e, (e as CustomEvent).detail.node);
                });
                navTreeContainer.appendChild(navTree);
            }

            clearInterval(this.keepAliveInterval)
            const keepAliveTime = 60000 * 2 + Math.round(Math.random() * 60000)
            console.info("KEEP_ALIVE_TIME:", keepAliveTime)
            this.keepAliveInterval = setInterval(() => this.keepAlive(), keepAliveTime)

            if (loginDiv)
                loginDiv.remove()
        }

        this.showPreloader(false)
        this.hideLogin()

        try {
            if (this._startupUrl) {

                let routeKey = this._startupUrl

                this._startupUrl = ""

                let routeObj
                const paramsIdx = routeKey.indexOf("?")
                if (paramsIdx >= 0) {
                    routeObj = JSON.parse(decodeURI(routeKey.substr(paramsIdx + 1)))
                    routeKey = routeObj.target ?? routeKey.substr(0, paramsIdx)
                }

                while (routeKey.charAt(0) === "#" || routeKey.charAt(0) === "/")
                    routeKey = routeKey.substring(1)

                if (routeKey?.trim()) {
                    if (!routeObj) routeObj = this.findRoute(routeKey)?.route
                    if (routeObj) {
                        const curFrame = this.createFrame()
                        await this.loadRoute(routeObj, curFrame)
                    }
                }

            } else if (this.querySelector("#header ul")!.children.length === 0) {
                const curFrame = this.createFrame()
                await this.load(curFrame, "", { target: "home", caption: "Millennium", urlKey: "", text: "" }, null)
            }
        }
        catch (e) {
            console.error("Error loading startup URL " + this._startupUrl, e)
        }

        if (!this.isEmbedded) {
            setTimeout(() => this.notify("Login concluído", "success"), 0)
            void this.startNotifications()
        }
    }

    private currentHost() {
        let host
        if (localStorage) host = localStorage.getItem('defaultHost')
        if (host && host.indexOf(":") === -1) host = "https://" + host
        return host || (window.location.protocol + "//" + window.location.hostname + ":" + window.location.port)
    }

    private async defaultFinishLogin(host: string, userName: string, password: string) {
        if (localStorage) {
            localStorage.setItem('userName', userName)
            localStorage.setItem('defaultHost', host)
            if (Capacitor.isNativePlatform()) localStorage.setItem("password", btoa(password))
        }
        if (!this.inLogin) {
            this.showPreloader(true)
            try {
                let appName = localStorage.getItem("appname") || "B5WIN32"
                let licenceName = "retag"

                const licenceEl = this.querySelector<HTMLSelectElement>("#licence_type")
                if (licenceEl) {
                    licenceName = licenceEl.options[licenceEl.selectedIndex].value
                    appName = licenceName.toUpperCase()
                    if (licenceName === "loja" || licenceName === "retag")//legacy
                        appName = "B5WIN32"

                    localStorage.setItem("appname", appName)
                    localStorage.setItem("licencename", licenceName)
                }

                await this.login(appName, licenceName, this.currentHost(), userName, password)
                await this.loginSuccess()
            }
            catch (e: any) {
                this.showPreloader(false)
                throw e
            }
        }
    }

    private notificationButtonClick() {
        for (const n of this.notifiersList) n.action()
    }

    private async loginClick() {
        if (this.currentLoginCallback)
            try {
                const hostname = this.querySelector<HTMLInputElement>('#hostname')
                const username = this.querySelector<HTMLInputElement>("#username")
                const password = this.querySelector<HTMLInputElement>("#password")
                await this.currentLoginCallback(hostname?.value ?? "", username?.value ?? "", password?.value ?? "")
                this.currentLoginCallback = undefined
            } catch (e: any) {
                this.notify(e, "danger")
                throw e
            }
    }

    private currentFrame() {
        return (this.querySelector("#header ul .active") as any)?.mlnFrameInstance as IMillenniumFrame
    }

    private async loadRoute(route: IRoute, frame?: IMillenniumFrame) {
        const routeObj = route.key && this.findRoute(route.key)
        if (routeObj) {
            const moduleInfo = await this.showModule(routeObj.path[0]?.text ?? "")
            if (moduleInfo?.key === route.key) return
        }

        return this.load(frame ?? this.currentFrame(), route.key ?? "", route.target ? route : undefined)
    }

    private nodeSelected(args: any, node: IRoute & { _client?: boolean }) {
        this.hideSideBar(() => this.loadRoute(node))
    }

    /**
     * Resolve o texto amigável (título de aba) de uma rota a partir da árvore de menu `_routes`,
     * casando por key/urlKey/target normalizados (sem "#"/"/" à frente, case-insensitive).
     * Fallback para rotas que chegam sem `text`/`caption` no MODO BROWSER (ex.: URL "#/rota"
     * digitada à mão) — `_routes` só é populado quando a sidebar HTML existe. No embedded o
     * menu é nativo (`_routes` vazio) e o caption vem embutido na URL pelo binbrowser.
     * Retorna "" se não encontrar. (porte da master c9482cf61d1)
     */
    private captionFromMenu(rawKey: string): string {
        const norm = (s?: string) => (s || "").replace(/^[#/]+/, "").toLowerCase()
        const wanted = norm(rawKey)
        if (!wanted) return ""
        let found = ""
        const walk = (nodes?: IRoute[]) => {
            if (!nodes || found) return
            for (const n of nodes) {
                if (found) return
                if (n.nodes?.length) walk(n.nodes)
                else if (norm(n.key) === wanted || norm(n.urlKey) === wanted || norm(n.target) === wanted)
                    found = n.text || ""
            }
        }
        walk(this._routes)
        return found
    }

    private findRoute(key: string): { route: IRoute, path: IRoute[] } | undefined {
        function findNode(children: IRoute[] | undefined): { route: IRoute, path: IRoute[] } | undefined {
            if (children)
                for (let x = 0; x < children.length; x++)
                    if (children[x].nodes && children[x].nodes?.length) {
                        const node = findNode(children[x].nodes)
                        if (node) {
                            node.path.unshift(children[x])
                            return node
                        }
                    }
                    else if (children[x].key?.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0) {
                        return { route: children[x], path: [] }
                    }
        }
        return findNode(this._routes)
    }

    private hideLogin() {
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.style.display = "none"
        const contentFrame = this.querySelector<HTMLElement>("#content-frame")
        if (contentFrame)
            contentFrame.classList.add("visible")
        //we need to remove for safety and because of a (very) wird chrome behaviour that
        //starts triggering keydown events for all over the place
        const password = this.querySelector<HTMLInputElement>("#password")
        if (password)
            password.remove()
    }

    private handleLoginDone(session?: Session) {
        if (session)
            localStorage.setItem('sessionData', JSON.stringify(session.loginData))
        this.hideLogin()
    }

    private handleBlurHostname() {
        const hostInput = this.querySelector<HTMLInputElement>('#hostname')
        if (!hostInput) return

        localStorage.setItem('defaultHost', hostInput.value as string)
        void this.loadLicenceTypes()
    }

    private async loadLicenceTypes() {
        const licenceEl = this.querySelector<HTMLSelectElement>("#licence_type")
        if (licenceEl && licenceEl.children.length > 0) return

        const curName = Capacitor.isNativePlatform() ? "omni" : localStorage.getItem("licencename") || "omni"
        const result = await Client.get<any>("millenium:wtssystem.users.GetLicenceGroups", {}, { anonymous: true, licenceType: "mgt" })
        for (const item of result.value) {
            const option = document.createElement("option")
            option.textContent = item.DESCRIPTION
            option.value = item.NAME
            option.setAttribute("data-type", item.TYPE)
            option.selected = curName === item.NAME
            option.style.background = "var(--command-color)"
            option.style.color = "white"
            option.style.padding = "5px"
            if (licenceEl)
                licenceEl.append(option)
        }
    }

    private showInitialLogin(blank = false, message = "", callback = (host: string, user: string, pass: string) => this.defaultFinishLogin(host, user, pass)) {
        if (this.currentLoginCallback) throw Error("Login already in progress")

        clearInterval(this.keepAliveInterval)
        this.showPreloader(false)
        this.currentLoginCallback = callback
        const password = this.querySelector<HTMLInputElement>("#password")
        if (password)
            password.remove()
        //creates the pwd element
        const pwdGroup = this.querySelector<HTMLElement>("#pwd-group")
        if (pwdGroup)
            pwdGroup.innerHTML = `<input autocomplete="off" class="light-placeholder" id="password" type="password" placeholder="Senha" style="border:none;background:none;width:100%;color:black"/>`
        const loginMessage = this.querySelector<HTMLElement>("#login-message")
        if (loginMessage)
            loginMessage.textContent = message

        const contentFrame = this.querySelector<HTMLElement>("#content-frame")
        if (!blank && contentFrame)
            contentFrame.classList.remove("visible")

        const loginAnim = this.querySelector<HTMLElement>("#login_anim")
        if (loginAnim)
            loginAnim.classList.add("show-fadein")
        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.style.display = "block"

        const username = this.querySelector<HTMLInputElement>("#username")
        const hasUser = username && username.value !== ""

        if (localStorage) {
            const hostname = this.querySelector<HTMLInputElement>("#hostname")
            if (hostname)
                hostname.value = (blank) ? "" : localStorage.getItem("defaultHost") || ""
            if (username)
                username.value = (blank) ? "" : localStorage.getItem("userName") || ""
            const password = this.querySelector<HTMLInputElement>("#password")
            if (password)
                password.value = ""
        }

        if (!blank && hasUser) {
            if (username)
                username.readOnly = true
            const password = this.querySelector<HTMLInputElement>("#password")
            if (password)
                password.focus()
        } else {
            if (username) {
                username.readOnly = false
                username.focus()
            }
        }

        setTimeout(function () { loginAnim?.classList.remove("show-fadein") }, 1000)

        void this.loadLicenceTypes()
    }

    private async showUserOptions() {
        const menu = new Menu()
        const usrImg = this.querySelector<HTMLElement>("#usr-img")
        if (usrImg) {
            const result = await menu.show(usrImg, [
                this.userName,
                "-",
                "Logout"
            ])

            if (result === 2) {
                this.logout()
            }
        }
    }

    private filterRoutes(text: string): IRoute[] {

        function search(nodes: IRoute[]) {
            const searchResult = { nodes: [] as IRoute[], hasLeaf: false }
            for (const node of nodes) {
                if (node.nodes && node.nodes.length) {
                    const nodeResult = search(node.nodes)
                    searchResult.hasLeaf = searchResult.hasLeaf || nodeResult.hasLeaf
                    if (nodeResult.hasLeaf)
                        searchResult.nodes.push({ ...node, nodes: nodeResult.nodes })
                }
                else if (node.text?.match(searchRegex)) {
                    searchResult.hasLeaf = true
                    searchResult.nodes.push(node)
                }
            }
            return searchResult
        }

        const searchRegex = new RegExp(text, "i")
        const result = search(this._routes)
        if (result.hasLeaf)
            return result.nodes
        else
            return []
    }

    private handleSidebarSearch(e: Event) {
        clearTimeout(this._searchTimeout)
        this._searchTimeout = setTimeout(() => {
            const navTree = this.querySelector<MlnTreeView>('.sidebar .menu-tree')
            if (navTree) {
                const value = (e.target as HTMLInputElement).value
                const filteredRoutes = this.filterRoutes(value)
                navTree.treeData = filteredRoutes
                navTree.levels = value ? 10 : 1
            }
        }, 50)
    }

    private setupUI() {

        if (!((window as any)["millennium"] && (window as any)["millennium"].browser && (window as any)["millennium"].browser.isEmbedded)) {
            const moduleHeader = this.querySelector<HTMLElement>('.mln-module-header')
            if (moduleHeader)
                moduleHeader.style.display = "flex"
            const usrImg = this.querySelector<HTMLImageElement>('#usr-img')
            if (usrImg)
                usrImg.src = "https://www.gravatar.com/avatar?d=mm&s=28"
        }
        else {
            const moduleHeader = this.querySelector<HTMLElement>('.mln-module-header')
            if (moduleHeader)
                moduleHeader.style.display = "none"
        }

        if (Environment.isMobile)
            window.document.body.classList.add("mobile")

        if (this.isEmbedded)
            window.document.body.classList.add("mln-embedded")

        const menuBtn = this.querySelector<HTMLElement>('#menu-btn')
        if (menuBtn)
            menuBtn.onclick = (e) => {
                this.showSideBar()
                e.stopPropagation()
            }

        if (location.protocol === "file:" || Capacitor.isNativePlatform()) {
            const hostInput = this.querySelector<HTMLElement>('.mln-host-input')
            const inputEl = this.querySelector<HTMLInputElement>('#hostname')

            if (hostInput) hostInput.style.display = "block"

            if (inputEl) inputEl.onblur = () => this.handleBlurHostname()
        }

        const loginBtn = this.querySelector<HTMLElement>("#login")
        if (loginBtn)
            loginBtn.onclick = () => this.loginClick()

        const testeBtn = this.querySelector<HTMLElement>("#teste")
        if (testeBtn)
            testeBtn.onclick = () => {
                this.switchUser()
            }

        const usrImg = this.querySelector<HTMLElement>("#usr-img")
        if (usrImg)
            usrImg.onclick = () => this.showUserOptions()

        const logoutBtn = this.querySelector<HTMLElement>("#logout")
        if (logoutBtn)
            logoutBtn.onclick = () => this.logout()

        const loginDiv = this.querySelector<HTMLElement>("#login-div")
        if (loginDiv)
            loginDiv.onkeydown = (e) => {
                if (e.keyCode === 13) {
                    const loginBtn = this.querySelector<HTMLElement>("#login")
                    if (loginBtn)
                        loginBtn.click()
                }
            }

        const sidebarClose = this.querySelector<HTMLElement>("#sidebar-close")
        if (sidebarClose)
            sidebarClose.onclick = () => this.hideSideBar()
        const sidebarSearch = this.querySelector<HTMLInputElement>("#sidebar-search")
        if (sidebarSearch) {
            sidebarSearch.onkeyup = (e) => this.handleSidebarSearch(e);
            (sidebarSearch as any).onsearch = (e: any) => this.handleSidebarSearch(e)
        }

        const notificationButton = this.querySelector<HTMLElement>("#notification_button")
        if (notificationButton)
            notificationButton.onclick = () => this.notificationButtonClick()

        function getErrorMessage(obj: unknown) {
            if (!obj) return
            const message = (obj instanceof Error ? obj.message : String(obj)) || ""
            if (message.substring(0, 5) === "show:")
                return message.substring(5)
        }

        window.addEventListener("message", this.handleWindowMessage)

        window.addEventListener("error", event => {
            const message = getErrorMessage(event.error)
            if (message)
                this.notify(message, "danger")
        })

        window.addEventListener("unhandledrejection", event => {
            const message = getErrorMessage(event.reason)
            if (message)
                this.notify(message, "danger")
        })

        document.addEventListener("touchstart", function () { }, false)
        document.addEventListener("contextmenu", function (e: Event) {
            e.preventDefault()
        }, false)

        this.onLoginDone.subscribe((session) => this.handleLoginDone(session))

        var authInProcess = false
        this.onAuthFail.subscribe(async (options) => {
            if (authInProcess) return

            authInProcess = true
            try {
                localStorage.setItem('sessionData', '')
                const loginDiv = this.querySelector("#login-div")
                if (loginDiv)
                    loginDiv.classList.add("login-auth-fail")

                const password = localStorage.getItem("password")
                if (Capacitor.isNativePlatform() && password) {
                    await this.defaultFinishLogin(this.currentHost(), getDefaultSession().userName, atob(password))
                } else if (options && options.blank) {
                    const loginInfo = await showLogin(options)
                    if (loginInfo)
                        await this.defaultFinishLogin(this.currentHost(), loginInfo.username, loginInfo.password)
                } else if (!this.isEmbedded) {
                    do {
                        var loginInfo = await showLogin()
                        if (loginInfo)
                            try {
                                await this.defaultFinishLogin(this.currentHost(), loginInfo.username, loginInfo.password)
                            } catch (e: any) {
                                this.notify(e, "warning")
                                loginInfo = undefined
                            }
                    } while (!loginInfo)
                } else {
                    try {
                        const sessionId = await this.getSessionId()
                        const licenceType = sessionId.split('|')[4]
                        await this.joinSession(location.protocol + "//" + location.host, sessionId, {}, true, licenceType)
                    } catch (e) {
                        console.error(e)
                    }
                }
            } finally {
                authInProcess = false
            }
        })

        const mainBody = this.querySelector(".mln-mainbody")
        if (mainBody)
            mainBody.classList.add("mln-mainbody_ready")
    }

    private async startup(startupPage: string) {

        this.hideLogin()
        this._startupUrl = startupPage
        const rawSessionData = localStorage.getItem('sessionData')
        let sessionData
        try {
            sessionData = rawSessionData && JSON.parse(rawSessionData)
        } catch {
            sessionData = ""
        }
        if (!this.isEmbedded) {
            if (!sessionData)
                this.showInitialLogin()
            else {
                this.showPreloader(true)
                try {
                    await this.joinSession(this.currentHost(),
                        sessionData.session,
                        sessionData,
                        true,
                        localStorage.getItem("appname") || "")

                    await this.loginSuccess()
                } catch {
                    this.showInitialLogin()
                }
            }
        } else {
            try {
                const sessionId = await this.getSessionId()
                await this.joinSession(location.protocol + "//" + location.host,
                    sessionId,
                    {},
                    true)
                await this.loginSuccess()
            } catch (e) {
                console.error(e)
            }
        }
    }

    private async update() {
        const { currentBundleId } = await LiveUpdate.ready()

        const text = await Client.getText(getCurrentHost() + "/dist.zip.upd", {}, { anonymous: true })
        const checksum = text.split("\n").find(l => l.startsWith("CheckSum"))?.split("=")[1] ?? null

        if (checksum && checksum !== currentBundleId) {
            await LiveUpdate.downloadBundle({
                url: getCurrentHost() + "/dist.zip",
                bundleId: checksum,
            })
            await LiveUpdate.setNextBundle({ bundleId: checksum })

            const shouldUpdate = await millennium.browser.msgBox(
                "Deseja reiniciar o aplicativo para aplicar a atualização agora?",
                "Atualização disponível.",
                MsgBoxFlags.MB_YESNO
            ) === MsgBoxResult.IDYES

            if (shouldUpdate) void LiveUpdate.reload()
        }
    }

    public start() {
        //wireup all events
        this.setupUI()
        void this.startup(location.hash)

        if (Capacitor.isNativePlatform()) {
            void this.update()
        }
    }

    hideModuleHeader() {
        const moduleHeader = this.querySelector<HTMLElement>(".mln-module-header")

        if (moduleHeader)
            moduleHeader.style.display = "none"
    }

    showModuleHeader() {
        const moduleHeader = this.querySelector<HTMLElement>(".mln-module-header")

        if (moduleHeader)
            moduleHeader.style.display = "flex"
    }
}

customElements.define("millennium-browser", MillenniumBrowser)

export class MillenniumFrame implements IMillenniumFrame {
    private _isProcessing: boolean = false;
    private _bodyElement: HTMLElement
    private _tabElement: HTMLElement
    private _navElement: HTMLElement
    private _moduleName: string = ""
    private _key: any

    constructor(public readonly browser: MillenniumBrowser) {
        //create tab on the top navbar        
        let newTab = $("<li class='active'><a href='' style='float:left'></a><i class='fa fa-times nav-btn-close' style='margin-left:auto'></span></li>")
        $("#header").find("ul").append(newTab)

        //create tab on the left navbar        
        let newTabLeft = $("<li class='active' style='width:100%;float:left'><a href='' style='float:left'></a><i class='fa fa-times nav-btn-close' style='margin-left:auto;font-size:0.8em'></i></li>")
        $("#header-left").find("ul").append(newTabLeft)

        let newSheet = $("<div class='mln-content-frame'></div>")

        $("#content-frame").append(newSheet)

        newTabLeft.on("click", this.handleTabClick)
        newTab.on("click", this.handleTabClick)

        newTab.data("mln-tab-sheet", newSheet)
        newTabLeft.data("mln-tab-sheet", newSheet)

        this._bodyElement = newSheet[0]
        this._tabElement = newTab[0]
        this._navElement = newTabLeft[0]

        browser[FRAMES].add(this)
    }
    get key() {
        return this._key
    }
    set key(value) {
        this._key = value
    }
    get moduleName() {
        return this._moduleName
    }
    set moduleName(value: string) {
        this._moduleName = value
        this._bodyElement.setAttribute("data-module-name", value)
        this._tabElement.setAttribute("data-module-name", value)
        this._navElement.setAttribute("data-module-name", value)
    }
    get visible() {
        return !this._tabElement.hidden
    }
    set visible(value: boolean) {
        this._bodyElement.hidden = !value || !this._bodyElement.classList.contains("visible")
        this._tabElement.hidden = !value || !this._tabElement.classList.contains("visible")
        this._navElement.hidden = !value || !this._navElement.classList.contains("visible")
    }
    requestFullScreen() {
        $('.navbar').hide()
    }
    async switchUser(): Promise<void> {

    }
    async accessPrompt(message: string, key: string, userInfo?: any) {
        return this.browser.accessPrompt(message, key, userInfo)
    }
    async hasAccess(key: string | string[]) {
        if (typeof key === "string") {
            const access = await this.browser.hasAccess(key);

            if (typeof access === "object" && access !== null && "hasAccess" in access) {
                return !!(access as { hasAccess: boolean }).hasAccess;
            }

            return !!access;
        } else {
            const result: any = {}
            for (const item of key)
                result[item] = (await this.browser.hasAccess(item))
            return result
        }
    }
    private async closeTab(tabElement: HTMLElement) {
        let tabEl = $(tabElement)

        let lasttab = tabEl.prev()
        while (lasttab.length) {
            if (lasttab.attr("data-module-name") !== this._moduleName)
                lasttab = lasttab.prev()
            else
                break
        }

        if (!lasttab?.length) {
            lasttab = tabEl.next()
            while (lasttab.length) {
                if (lasttab.attr("data-module-name") !== this._moduleName)
                    lasttab = lasttab.next()
                else
                    break
            }
        }

        let wasActive = tabEl.has("active")
        let module = tabEl.data("mln-tab-sheet").data("mln-module-instance")
        if (module) {
            if (module.OnDestroy)
                await module.OnDestroy()
            else if (module.destroy)
                await module.destroy()
            module.frame = null
        }
        tabEl.data("mln-tab-sheet").data("mln-module-instance", null)
        tabEl.data("mln-tab-sheet").remove()
        tabEl.remove()

        if (lasttab.length > 0 && wasActive) {
            lasttab.click()
        } else {
            // Fechou a aba ATIVA e não há irmã do mesmo módulo para assumir: zera o
            // estado de módulo ativo do browser para que reabrir o MESMO link volte a
            // carregar (senão o guard `currentModuleName === moduleName` em showModule
            // aborta e só volta a funcionar após visitar outro módulo e retornar).
            // (porte da master c9482cf61d1)
            if (wasActive)
                this.browser.resetActiveModule()
            if (!millennium.browser.isEmbedded)
                history.pushState("", document.title, window.location.pathname)
        }
    }
    private async activateTab(tabElement: HTMLElement) {
        let tabEl = $(tabElement).closest("li")

        //deactivate others tabs
        tabEl.closest("ul").children().filter((_, e) => e !== tabEl.get(0) && e.getAttribute("data-module-name") === this._moduleName).removeClass(["active"])
        //content
        $("#content-frame").children().filter((_, e) => e !== tabEl.get(0) && e.getAttribute("data-module-name") === this._moduleName).removeClass(["active", "visible"]).attr("hidden", "true")

        //activate this
        tabEl.addClass(["active", "visible"])
        tabEl.removeAttr("hidden")
        document.title = (!millennium.browser.isEmbedded ? "Millennium ● " : "") + (<HTMLAnchorElement>tabElement).text

        tabEl.data("mln-tab-sheet").addClass(["visible", "active"])
        tabEl.data("mln-tab-sheet").removeAttr("hidden")

        const frame = tabEl.data("mln-tab-sheet").data("mln-module-instance")
        if (frame && frame.activate) await frame.activate()
        if (!millennium.browser.isEmbedded)
            history.pushState(null, "", (tabElement as HTMLLinkElement).href.substring((tabElement as HTMLLinkElement).href.indexOf("#")))
    }
    private async activateTabs() {
        const navLink = this._navElement.querySelector("a")
        const tabLink = this._tabElement.querySelector("a")
        navLink && await this.activateTab(navLink)
        tabLink && await this.activateTab(tabLink)
        window.dispatchEvent(new Event("resize"))
    }
    handleTabClick = async (e: Event) => {
        if (!e.target) return
        e.preventDefault()

        if ($(e.target).hasClass("nav-btn-close") && $(e.target).closest("li").hasClass("active"))
            await this.close()
        else
            await this.activateTabs()
    }
    navigateSc(key: string, data: string, vars: Object, caption?: any) {
        return this.browser.frame_navigateSc(this, key, data, vars, caption)
    };
    navigate(place: string, vars?: Object) {
        return this.browser.frame_navigate(this, place, vars || {})
    };
    close = async () => {
        const navBtnClose = this._navElement.querySelector(".nav-btn-close")
        const tabBtnClose = this._tabElement.querySelector(".nav-btn-close")
        navBtnClose && navBtnClose.parentElement && await this.closeTab(navBtnClose.parentElement)
        tabBtnClose && tabBtnClose.parentElement && await this.closeTab(tabBtnClose.parentElement)
        this._bodyElement.remove()

        this.browser.frame_close(this)
        this.browser[FRAMES].delete(this)
    };
    setCaption(value: string) {
        const tabLink = this._tabElement.querySelector("a")
        const navLink = this._navElement.querySelector("a")
        if (tabLink) tabLink.text = value
        if (navLink) navLink.text = value
        this.browser.frame_setCaption(this, value)
    };
    setUrl(value: string) {
        const tabLink = this._tabElement.querySelector("a")
        const navLink = this._navElement.querySelector("a")
        if (tabLink) tabLink.href = value
        if (navLink) navLink.href = value
        this.browser.frame_setUrl(this, value)
    };
    activate() {
        this.activateTabs()
        this.browser.frame_activate(this)
    };
    get element(): HTMLElement {
        return this._bodyElement
    };
    set isProcessing(value: boolean) {
        this._isProcessing = value
    };
    get isProcessing() {
        return this._isProcessing
    }

    getActivityElement(element?: HTMLElement): MlnActivityIndicator | undefined {
        return (element ?? this._bodyElement).querySelector(":scope > mln-activity-indicator") as MlnActivityIndicator | undefined
    }
    beginProcessing(element?: HTMLElement): MlnActivityIndicator {

        const parentEl = element ?? this._bodyElement
        let activityEl = parentEl.querySelector(":scope > mln-activity-indicator") as MlnActivityIndicator | undefined

        if (!activityEl) {
            activityEl = document.createElement("mln-activity-indicator")
            parentEl.appendChild(activityEl)
        }

        activityEl.begin()

        return activityEl
    }
    endProcessing(error?: string, element?: HTMLElement) {
        if (error) this.browser.notify(error, "warning")
        this.getActivityElement(element)?.end()
    }
    lazyLoad(lazyFacet: LazyLoadFacet, callback: () => void): void {
        if (lazyFacet.timer) clearInterval(lazyFacet.timer)
        lazyFacet.timer = setTimeout(() => {
            callback()
        }, lazyFacet.delay)
    }
    notify(message: string, type: "warning" | "danger" | "success" | "warning-auto-hide") {
        this.browser.notify(message, type)
        this.browser.frame_notify(this, message, type)
    }
    activity<T extends PromiseLike<any>>(waiter: T, feedBackData?: FeedBackData, silent?: boolean, transaction: string | undefined = undefined): T {

        if (!waiter.then) return waiter
        let currentMessage = 1
        let messageTimer: any | undefined
        const targetEl = feedBackData?.element ?? getTopOverlayElement()
        const activityEl = this.beginProcessing(targetEl)
        if (transaction)
            this.getActivityElement(targetEl)?.transaction(transaction)

        const handleError = (error: any) => {
            this.endProcessing(silent ? undefined : error, targetEl)
            clearInterval(messageTimer)
            return Promise.reject(error) as any
        }

        try {
            if (feedBackData) {
                activityEl.caption = (feedBackData.waitMessages?.[0]) ?? ""
                if (feedBackData.waitMessages && feedBackData.estimatedTime)
                    messageTimer = setInterval(() => {
                        activityEl.caption = feedBackData.waitMessages?.[currentMessage] ?? ""
                        currentMessage++
                        if (currentMessage >= (feedBackData.waitMessages?.length ?? 0)) clearInterval(messageTimer)
                    }, feedBackData.estimatedTime / feedBackData.waitMessages.length)
            } else
                activityEl.caption = ""

            return waiter.then((result: any) => {
                this.endProcessing(undefined, targetEl)
                clearInterval(messageTimer)
                return result
            }, handleError) as any
        } catch (error: any) {
            return handleError(error)
        }
    }
    async loadExtension(name: string): Promise<any> {
        return this.browser.loadExtension(name)
    }
}